module.exports = __webpack_public_path__ + "static/media/filmfront.a319e115.png";